import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import ExpandLess from '@material-ui/icons/ExpandLessOutlined';
import ExpandMore from '@material-ui/icons/NavigateNextOutlined';
import { v4 } from 'uuid';
import { useHistory, withRouter } from 'react-router-dom'
import React from 'react'
import './sidebaritem.css'


function Sidebaritem(props: any) {
    const { title, pathTo, icon, routes } = props;
    const [open, setOpen] = React.useState(false);
    const [active, setActive] = React.useState(false)
    const { location, push } = useHistory();

    React.useEffect(() => {
        if (location.pathname === pathTo) {
            setActive(true)
        } else {
            setActive(false)
        }
    }, [location.pathname])

    const handleClick = () => {
        setOpen(!open);
        if (pathTo) {
            push(pathTo)
        }
    };

    const handleChildClick = (path: any) => {
        if (path) {
            push(path)
        }
        if (routes.length > 0) {
            setOpen(true);
            setActive(true)
        }
    }

    return (
        <div className="sidebar_list_item">
            <ListItem button onClick={handleClick} style={{ padding: '10px', borderRadius: '5px' }}>
                <ListItemIcon>
                    <div className={`${active && "logoactive"}`} style={{ display: 'grid', placeItems: 'center', padding: '3px', borderRadius: '8px', boxShadow: '0 1px 3px#ccc' }}>
                        <icon.Icon size={icon.size} />
                    </div>
                </ListItemIcon>
                <ListItemText primary={title} className={`side_MuiListItemText-root ${active && "sidebarActive"}`} style={{ marginLeft: '-15px' }} />
                {
                    title == "Phone Numbers New" && (
                        <div className="badge">
                            {props.numberValidateErrors?.totalErrors}
                        </div>
                    )
                }
                {title === "Addons" || title === "Phone Numbers" || title === "Efone clients" ? "" : (open && routes.length > 0) ? <ExpandLess style={{ color: 'grey' }} /> : <ExpandMore style={{ color: 'grey' }} />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {
                    routes.map((route: any) => {
                        const childActive = location.pathname === route.pathTo;
                        if (route.status)
                            return route.routes?.length > 0 ? (
                                <div style={{ paddingLeft: 12 }} key={v4()}>
                                    <Sidebaritem {...route} numberValidateErrors={props.numberValidateErrors} />
                                </div>
                            ) : (
                                <List component="div" disablePadding onClick={() => handleChildClick(route.pathTo)} key={v4()}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <div className={`${childActive && "logoactive"}`} style={{ display: 'grid', placeItems: 'center', padding: '3px', borderRadius: '8px', boxShadow: '0 1px 3px#ccc' }}>
                                                {/* <icon.Icon size={icon.size} /> */}
                                                <route.icon.Icon />
                                            </div>
                                        </ListItemIcon>
                                        <ListItemText primary={route.title} />
                                        {
                                            (route.title == "Number Provider" || route.title == "SMS Providers" || route.title == "e911 Provider") && (
                                                <div className="badge">
                                                    {
                                                        route.title == "Number Provider" ?
                                                            props.numberValidateErrors?.numbersError
                                                            :
                                                            route.title == "SMS Providers" ?
                                                                props.numberValidateErrors?.smsError
                                                                :
                                                                route.title == "e911 Provider" ?
                                                                    props.numberValidateErrors?.e911Error
                                                                    :
                                                                    ""
                                                    }
                                                </div>
                                            )
                                        }
                                    </ListItem>
                                </List>
                            )
                    })
                }
            </Collapse>
        </div>
    )
}

export default withRouter(Sidebaritem)
